interface SkeletonCardProps {
  title?: string;
  fullWidth?: boolean;
}

export function SkeletonCard({ title, fullWidth }: SkeletonCardProps) {
  return (
    <div className={`bg-surface border border-border rounded-lg p-[18px] sm:px-[22px] animate-pulse ${fullWidth ? 'col-span-full' : ''}`}>
      {title && (
        <span className="block text-[10px] font-semibold tracking-wider uppercase text-placeholder/50 mb-2">
          {title}
        </span>
      )}
      <div className="space-y-2.5">
        <div className={`h-3.5 bg-border/60 rounded ${fullWidth ? 'w-3/5' : 'w-2/5'}`} />
        <div className="h-3 bg-border/40 rounded w-full" />
        <div className="h-3 bg-border/40 rounded w-4/5" />
        {fullWidth && <div className="h-3 bg-border/40 rounded w-3/5" />}
      </div>
    </div>
  );
}
